export const environment = {
  APIKEY: "AIzaSyCulx3VGIvw9UbAOBOx7skRQoL4snf5JYA",
  AUTHDOMAIN: "myportfolio-ae25c.firebaseapp.com",
  PROJECTID: "myportfolio-ae25c",
  STORAGEBUCKET: "myportfolio-ae25c.appspot.com",
  MESSAGINGSENDERId: "236927758910",
  APPID: "1:236927758910:web:cdd24337de0c61028e976f",
  MEASUREMENTID: "G-P52DHRZK8V"
}